import type { PropsWithChildren } from 'react';
import { Text } from '@/ui-components/atoms/Text/Text';
import styles from './sportsScheduleStrip.module.scss';

export interface SportsScheduleGroupProps {
    dateLabel: string;
}

export function SportsScheduleGroup({ dateLabel, children }: PropsWithChildren<SportsScheduleGroupProps>) {
    return (
        <div className={styles.group}>
            <Text tag="h3" className={styles.dateHeading} data-cy="components-contextual-sports-date-title">
                {dateLabel}
            </Text>
            <div className={styles.strips}>{children}</div>
        </div>
    );
}
